import IcLockIcon from './component'

export default IcLockIcon
